<template>
  <div>
    <a-dialog
      v-model="isOpen"
      :max-width="width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
      persistent
    >
      <v-card>
        <v-toolbar :color="options.color" dense>
          <span>{{ $t("lblUnsavedData") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon large>
            <v-icon>mdi-comment-question</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4 black--text">
          <slot name="text">
            {{ $t("msgUnsavedData") }}
          </slot>
        </v-card-text>
        <v-card-actions class="pt-3 justify-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">   
              <a-btn
              color="primaryDark"
              class="mr-2" 
              small
              @click="actionClick('save')"
              v-on="on" v-bind="attrs"
              ><span>{{ $t("btnSave") }}</span></a-btn
            > 
            </template>
          <span> {{ $t("btnSave") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">   
          <a-btn
            v-on="on" v-bind="attrs"
            color="secondary"
            small
            @click="actionClick('discard')"
            class="mr-2" 
            ><slot name="discard"
              ><span>{{ $t("btnDiscard") }}</span></slot
            >
          </a-btn>
          </template>
          <span> {{ $t("btnDiscard") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }"> 
          <a-btn
            v-on="on" v-bind="attrs"
            color="secondary"
            small
            @click="actionClick('cancel')"
            ><span>{{ $t("btnCancel") }}</span>
          </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
  </div>
</template>
<script>
import ADialog from "../wrapper-component/ADialog.vue";
import ABtn from "../wrapper-component/ABtn.vue";
export default {
  name: "PreventConfirmation",
  components: {
    ADialog,
    ABtn
  },
  props: {
    prevent: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      options: {
        color: "primaryLight1",
        width: 400,
        zIndex: 2000,
        noconfirm: false,
        yesNoButtons: false,
      },
      isOpen: this.prevent,
      nextRouteParams: null,
      unregisterRouteGuard: () => {},
    };
  },
  mounted() {
    this.isOpen = this.prevent;
  },
  watch: {
    prevent() {
      this.isOpen = this.prevent;
    },
  },
  methods: {
    actionClick,
  },
};

function actionClick(name) {
  this.isOpen = false;
  const params = { ...this.nextRouteParams };
  this.$emit(name, params);
}
</script>
